(() => {
  const init = async root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-catalog-grid]');
    const form = root.querySelector('[data-catalog-controls]');
    const status = root.querySelector('[data-catalog-status]');
    const more = root.querySelector('[data-catalog-more]');
    const retry = root.querySelector('[data-catalog-retry]');
    let cards = [...grid.querySelectorAll('[data-catalog-card]')], limit, next = root.querySelector('[data-catalog-next]')?.href, loading = false;
    const pageSize = () => innerWidth < 750 ? 8 : innerWidth < 990 ? 12 : 16;
    const seed = Math.floor(Date.now() / 86400000);
    const hash = value => { let n = seed; for (const char of value) n = Math.imul(n ^ char.charCodeAt(0), 16777619); return n >>> 0; };
    const novelLinks = new Set();
    if (root.dataset.home === 'true') {
      const firstRow = document.querySelector('[data-ss-product-row], [data-catalog-row]');
      firstRow?.querySelectorAll('a[href*="/products/"]').forEach(a => novelLinks.add(new URL(a.href).pathname));
    }
    const isNew = card => novelLinks.has(new URL(card.querySelector('a').href).pathname);
    const isMug = card => ['mug', 'mugs', 'taza', 'tazas', 'tasse', 'tasses'].includes((card.dataset.type || '').toLowerCase());
    const fields = form.elements;
    const filterToggle = form.querySelector('[data-catalog-filter-toggle]');
    const filterPanel = form.querySelector('[data-catalog-filter-panel]');
    const setFiltersOpen = open => {
      filterToggle?.setAttribute('aria-expanded', String(open));
      if (filterPanel) filterPanel.hidden = !open;
    };
    filterToggle?.addEventListener('click', () => setFiltersOpen(filterToggle.getAttribute('aria-expanded') !== 'true'));
    let maxPrice = Infinity;
    const restore = () => {
      const params = new URL(location.href).searchParams;
      for (const name of ['sort_by','catalog_type','catalog_price']) if (params.has(name)) fields[name].value = params.get(name);
      if (!fields.sort_by.value) fields.sort_by.value = 'discovery';
      fields.catalog_available.checked = params.get('catalog_available') === '1';
    };
    const render = (writeURL = false, reset = true) => {
      if (reset) limit = pageSize();
      maxPrice = fields.catalog_price.value === '' ? Infinity : Number(fields.catalog_price.value) * 100;
      const type = fields.catalog_type.value, sort = fields.sort_by.value;
      const selected = cards.filter(card => (!type || card.dataset.type === type) && Number(card.dataset.price) <= maxPrice && (!fields.catalog_available.checked || card.dataset.available === 'true'));
      selected.sort((a,b) => {
        if (sort === 'created-descending') return Number(b.dataset.created)-Number(a.dataset.created) || b.dataset.id.localeCompare(a.dataset.id);
        if (sort === 'created-ascending') return Number(a.dataset.created)-Number(b.dataset.created) || a.dataset.id.localeCompare(b.dataset.id);
        if (sort === 'price-ascending') return Number(a.dataset.price)-Number(b.dataset.price) || a.dataset.title.localeCompare(b.dataset.title);
        if (sort === 'price-descending') return Number(b.dataset.price)-Number(a.dataset.price) || a.dataset.title.localeCompare(b.dataset.title);
        if (sort === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title, document.documentElement.lang);
        return Number(a.dataset.giftPriority ?? 2)-Number(b.dataset.giftPriority ?? 2) || Number(isNew(a))-Number(isNew(b)) || Number(isMug(a))-Number(isMug(b)) || hash(a.dataset.id)-hash(b.dataset.id);
      });
      cards.forEach(card => {card.hidden = true;});
      const fragment = document.createDocumentFragment();
      selected.forEach((card,index) => {card.hidden = index >= limit;fragment.append(card);});
      grid.append(fragment);
      status.textContent = selected.length ? `${Math.min(limit, selected.length)} / ${selected.length} ${status.dataset.countLabel}` : status.dataset.emptyLabel;
      more.hidden = limit >= selected.length;
      if (writeURL) {
        const url = new URL(location.href);
        ['sort_by','catalog_type','catalog_price','catalog_available','page'].forEach(key => url.searchParams.delete(key));
        if (sort !== 'discovery') url.searchParams.set('sort_by',sort);
        if (type) url.searchParams.set('catalog_type',type);
        if (fields.catalog_price.value !== '') url.searchParams.set('catalog_price',fields.catalog_price.value);
        if (fields.catalog_available.checked) url.searchParams.set('catalog_available','1');
        history.replaceState(null,'',url);
      }
    };
    const finish = () => {
      const currentType = fields.catalog_type.value;
      fields.catalog_type.querySelectorAll('option:not(:first-child)').forEach(option => option.remove());
      [...new Set(cards.map(card => card.dataset.type).filter(Boolean))].sort((a,b)=>a.localeCompare(b)).forEach(type => fields.catalog_type.add(new Option(cards.find(card=>card.dataset.type===type)?.dataset.typeLabel || type,type)));
      fields.catalog_type.value = currentType;
      if (root.dataset.home === 'true' && novelLinks.size === 0) {
        [...cards].sort((a,b)=>Number(b.dataset.created)-Number(a.dataset.created)||b.dataset.id.localeCompare(a.dataset.id)).slice(0,12).forEach(card=>novelLinks.add(new URL(card.querySelector('a').href).pathname));
      }
      restore();
      if (fields.catalog_type.value || fields.catalog_price.value !== '' || fields.catalog_available.checked) setFiltersOpen(true);
      form.hidden = false;
      render();
    };
    const load = async () => {
      if (loading) return;
      loading = true;
      retry.hidden = true;
      try {
        const seenPages = new Set();
        while (next) {
          status.textContent = status.dataset.loadingLabel;
          const url = new URL(next);
          url.searchParams.set('section_id',root.dataset.section);
          if (seenPages.has(url.href)) throw Error('Repeated catalog page');
          seenPages.add(url.href);
          const response = await fetch(url, {headers:{Accept:'text/html'}});
          if (!response.ok) throw Error('Catalog unavailable');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const fetchedRoot = doc.querySelector('[data-shop-catalog]');
          if (!fetchedRoot) throw Error('Missing catalog');
          const known = new Set(cards.map(card=>card.dataset.id));
          const additions = [...fetchedRoot.querySelectorAll('[data-catalog-card]')].filter(card=>!known.has(card.dataset.id));
          additions.forEach(card=>grid.append(card));
          cards.push(...additions);
          next = fetchedRoot.querySelector('[data-catalog-next]')?.getAttribute('href');
          if (next) next = new URL(next,location.href).href;
        }
        root.querySelector('[data-catalog-next]')?.remove();
        finish();
      } catch {
        status.textContent = status.dataset.errorLabel;
        retry.hidden = false;
      } finally {loading = false;}
    };
    form.addEventListener('submit',event=>event.preventDefault());
    form.addEventListener('change',()=>render(true));
    fields.catalog_price.addEventListener('input',()=>render(true));
    form.addEventListener('reset',()=>setTimeout(()=>render(true),0));
    more.addEventListener('click',()=>{limit+=pageSize();render(false,false);});
    retry.addEventListener('click',load);
    window.addEventListener('popstate',()=>{form.reset();setTimeout(()=>{restore();render();},0);});
    limit = pageSize();
    cards.forEach((card,index)=>{card.hidden=index>=limit;});
    await load();
  };
  const mount = () => document.querySelectorAll('[data-shop-catalog]').forEach(init);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mount,{once:true}); else mount();
  document.addEventListener('shopify:section:load',mount);
})();

